import { loadFeedback } from './../state/feedback/feedback.actions';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Feedback } from '../models/Feedback';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private apiUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/Feedbacks`;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('token');
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  submitFeedback(
    feedbackText: string,
    rating: number,
    userName: string
  ): Observable<Feedback> {
    return this.http.post<Feedback>(
      this.apiUrl,
      { feedbackText, rating, userName },
      {
        headers: this.getHeaders(),
      }
    );
  }

  loadFeedback(): Observable<Feedback[]> {
    return this.http.get<Feedback[]>(this.apiUrl, {
      headers: this.getHeaders(),
    });
  }
}
